import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/dtm';

const ConsultationRoute: React.FC = () => {

  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const isConsultation = application && application.id == 0

  return isConsultation ? <Outlet /> : <Navigate to="/home" />;
};

export default ConsultationRoute;